module.exports = __webpack_public_path__ + "static/media/final_scf_and_tf_invoice_overview.3e4c7787.mp4";